var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "trash-simple_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 16v26a4 4 0 01-4 4H13a4 4 0 01-4-4V16M3 10h42M24 22v15M17 22v15M31 22v15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M17 10V2h14v8"
  }))));
}

export default SvgTrashSimple;